var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('div',{staticClass:"checkbox-toggle",class:{'is-active': _vm.value},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('i',{staticClass:"fa fa-check"})]),_c('div',{staticClass:"checkbox-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }